import { render, staticRenderFns } from "./ADeliveryWaySelector.vue?vue&type=template&id=4c8402ba&"
import script from "./ADeliveryWaySelector.vue?vue&type=script&lang=js&"
export * from "./ADeliveryWaySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports